import React from 'react';
import Button from "@material-ui/core/Button/Button";
import Card from "@material-ui/core/Card/Card";
import Grid from "@material-ui/core/Grid/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import makeStyles from "@material-ui/core/styles/makeStyles";

import { loginInfo1, loginInfo2 } from "../containers/loginPage/constants";

const useStyles = makeStyles(() => ({
  button: {
    margin: '28px 5px 5px 10px',
    backgroundColor: '#283f60',
    color: 'white',
    border: '1px solid #1a314c',
    '&:hover': {
      backgroundColor: '#1a314c',
      border: '1px solid #f6edd4',
    }
  },
  infoCard: {
    marginTop: '60px',
    width: '90%',
    border: '1px solid black'
    // border: '3px solid transparent',
    // borderImage: 'linear-gradient(left, #99d6ce 15%, #f2642f 50%, #f8c12c 90%) 30',
    // boxShadow: '0 0 20px 2px #283f60',
  },
  accessCode: {
    border: '1px solid #0c984b',
    // width: '55%',
    padding: '0px 3px 3px 8px',
  },
  input: {
    // width: '60%'
    marginTop: '10px'
  }
}));

const LoginBox = ({ accessCode, handleSubmit, setAccessCode }) => {
  const classes = useStyles();

  return (
    <Grid container justify="center">
      <div className='info-div'>
        <Card className={classes.infoCard}>

          <Grid item xs={12}>
            <div className='login-info'>
              <h2>Welcome to the STEM Week Challenge. Log in here.</h2>
              <p>{loginInfo1}</p>
              <p>{loginInfo2}</p>
            </div>
          </Grid>

          <Grid item xs={12}>
            <div className='access-code'>
              <Card className={classes.accessCode}>
                <form onSubmit={handleSubmit}>
                  <TextField
                    className={classes.input}
                    label="Access Code"
                    helperText="Enter your Access Code above"
                    onChange={(e) => setAccessCode(e.target.value)}
                    variant="filled"
                  />
                  <Button
                    className={classes.button}
                    disabled={accessCode.length < 1}
                    onClick={handleSubmit}
                    variant="contained"
                  >
                    Submit
                  </Button>
                </form>
              </Card>
            </div>
          </Grid>

        </Card>
      </div>
    </Grid>
  );
};

export default LoginBox;
